import { useState } from "react";
import { config, renderTokens } from "@/config/eventConfig";
import { usePersistentState } from "@/hooks/usePersistentState";

export const PromptReflection = () => {
  const questions = config.reflection.questions;
  const [answers, setAnswers] = useState(() => questions.map(() => ""));
  const [done, setDone] = usePersistentState("ps.reflectionDone", false);
  const [copied, setCopied] = useState(false);

  const copyReflections = async () => {
    const text = questions
      .map((q, i) => `${q}\n${answers[i] || ""}`)
      .join("\n\n");
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard unavailable
    }
  };

  return (
    <div data-testid="prompt-reflection">
      <div className="space-y-4">
        {questions.map((q, i) => (
          <div
            key={i}
            data-testid={`reflection-card-${i}`}
            className="bg-white border border-sand p-6"
          >
            <div className="flex gap-5">
              <span className="font-display text-5xl leading-none text-orange shrink-0">
                {i + 1}
              </span>
              <div className="flex-1">
                <p className="text-lg mb-3">{q}</p>
                <textarea
                  data-testid={`reflection-answer-${i}`}
                  rows={2}
                  value={answers[i]}
                  onChange={(e) =>
                    setAnswers((a) => {
                      const next = [...a];
                      next[i] = e.target.value;
                      return next;
                    })
                  }
                  className="w-full resize-none bg-cream/40 border border-sand focus:border-orange focus:outline-none px-3 py-2"
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 flex flex-wrap items-center gap-4">
        <p data-testid="reflection-save-line" className="text-ink">
          {renderTokens(config.reflection.save_line)}
        </p>
        <button
          data-testid="copy-reflections"
          onClick={copyReflections}
          className="text-sm border border-ink/20 px-4 py-1.5 hover:border-orange hover:text-orange-dark transition-colors duration-150"
        >
          {copied ? "Copied" : "Copy for your Project"}
        </button>
      </div>

      <div className="mt-6">
        <button
          data-testid="mark-done"
          onClick={() => setDone((d) => !d)}
          className={`px-6 py-3 transition-colors duration-150 ${
            done
              ? "bg-teal text-white"
              : "bg-orange hover:bg-orange-dark text-white"
          }`}
        >
          {done ? `✓ ${config.ui.part3.done}` : config.ui.part3.mark_done}
        </button>
      </div>
    </div>
  );
};
